import React from "react";
import {createMarkup} from "../../utils/createMarkup";

const StringToJSX = ({ text }) => (
  <div dangerouslySetInnerHTML={createMarkup(text)} />
);

export default StringToJSX;